import { createFormHookContexts } from "@tanstack/react-form";
import { useStore } from "@tanstack/react-store";

// export useFieldContext for use in your custom components
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

/** TanStack Standard Schema field errors are plain strings; function validators may return `{ message }`. */
export function getFieldErrorMessage(errors: unknown[]): string | undefined {
  const first = errors[0];
  if (first == null) return undefined;
  if (typeof first === "string") return first;
  if (typeof first === "object" && "message" in first) {
    const message = (first as { message?: unknown }).message;
    return message == null ? undefined : String(message);
  }
  return undefined;
}

/**
 * Show errors after touch/blur or any submit attempt.
 * Uses `field.form` — fieldComponents live under AppField; `useFormContext` requires AppForm.
 * @see https://github.com/TanStack/form/issues/1360
 */
export function useShowFieldError(errors: unknown[]) {
  const field = useFieldContext();
  const submissionAttempts = useStore(field.form.store, (state) => state.submissionAttempts);

  return (
    errors.length > 0 &&
    (field.state.meta.isTouched || field.state.meta.isBlurred || submissionAttempts > 0)
  );
}
